import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry, themeQuartz } from 'ag-grid-community';
import "ag-grid-enterprise";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import { BankToBankTransferTable, colDefs, rowData, table2ColDefs, table2Data } from "./BankToBankTransferTable";
import { CommonValidationMessages } from "../../../utils/Messages";
import { isValidForm } from "../../../utils/validation/CommonValidator";
import moment from "moment";
import { decryptAES } from "../../../utils/Encryption";
import { Navigate } from "react-router-dom";
import { permission } from "../../../utils/enums/ValidationMessage";

class BankToBankTransfer extends Component {
    constructor(props) {
        super(props);
        this.accountTransactionServices = new AccountTransactionServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            urlId: 0,
            prop: {},
            caption: "",
            colName: "",
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            rowData: [],
            colDefs: [],
            table2Data: [],
            idBankToBankTransfer: 0,
            bankToBankDetails: {
                idBankToBankTransfer: 0,
                transferNo: "",
                transferDate: "",
                chequeDate: "",
                refNo: "",
                amount: "",
                remarks: "",
                //
                employeeList: [],
                idEmployee: 0,
                employeeName: "",
                mainEmployeeList: [],
                aCCSubHeadList: [],
                mainACCSubHeadList: [],
                idGeneralProduct: 0,
                productName: "",
                bankList: [],
                mainBankList: [],
                toBankList: [],
                mainToBankList: [],
                idBank: 0,
                bankName: "",
                idSelectBank: 0,
                selectBankName: "",
                paymentModeList: [],
                mainPaymentModeList: [],
                idPaymentMode: 0,
                paymentMode: "",
                idFinancialYear: 0,
                e_Date: "",
                updateStatus: 0,
                chequeNoList: [],
                mainChequeNoList: [],
                idChequeBookDetails: 0,
                chequeNo: "",
                seriesList: [],
                mainSeriesList: [],
                idChequeBookMaster: 0,
                chequeBookSeries: "",
                fromAC: 0,
                fromACType: "",
                fromAccountTypeId: 2,
                fromAccountTypeName: "DEBIT",
                selectBankTypeId: 1,
                selectBankTypeName: "CREDIT",
                types: [
                    {
                        id: 1,
                        name: "CREDIT",
                    },
                    {
                        id: 2,
                        name: "DEBIT",
                    }
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                transferDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                // idGeneralProduct: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "account sub head"
                //         ),
                //     },
                // ],
                idPaymentMode: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "payment mode"
                        ),
                    },
                ],
                fromAC: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            " from account"
                        ),
                    },
                ],
                fromAccountTypeId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "from account type"
                        ),
                    },
                ],
                idBank: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "select bank"
                        ),
                    },
                ],
                // selectBankType: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "select bank type"
                //         ),
                //     },
                // ],
                // idChequeBookMaster: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "select series"
                //         ),
                //     },
                // ],
                // idChequeBookDetails: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "cheque no"
                //         ),
                //     },
                // ],
                // chequeDate: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "cheque date"
                //         ),
                //     },
                // ],
                // refNo: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "reference no"
                //         ),
                //     },
                // ],
                amount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],
                // authorisedBy: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "authorised by"
                //         ),
                //     },
                // ],
            },
        };
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    handleCellClick = (event) => {
        //if (event.colDef.field === "piQty") {
        //debugger
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Bank To Bank Transfer");
        //}
    };

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }


        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_GeneralProductSelect();
            });
        } else {
            // window.location.href = "/Login";
        } setTimeout(() => {
            this.removeDefaultBorders();
        }, 100)
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);

    };
    removeDefaultBorders = () => {
        // Select pinned columns and headers
        const pinnedHeader = document.querySelector(".ag-pinned-left-header");

        // Remove border from header
        if (pinnedHeader) {
            pinnedHeader.style.borderRight = "none";
        }

        // Function to remove borders from all pinned cells
        const removeCellBorders = () => {
            const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
            pinnedCells.forEach((cell) => {
                cell.style.borderRight = "none";
            });
        };

        // Initial removal of cell borders
        removeCellBorders();

        // 🔹 MutationObserver: Ensure AG Grid does not reapply the border
        const observer = new MutationObserver(() => {
            if (pinnedHeader) pinnedHeader.style.borderRight = "none";
            removeCellBorders(); // Continuously remove borders from new cells
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };
    // onGridScroll = (event) => {
    //     const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // Show border when scrolling right
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";
    //     } else {
    //         // Hide border when at the left
    //         if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";
    //     }
    // };

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Bank To Bank Transfer",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: this.state.idUser,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            minWidth: this.getColumnWidth(key),
                            pinned: ["transferNo", "transferDate"].includes(key) ? true : false,
                            width: this.getPinnedWidth(key),
                            hide: ["sR.No", "idBankToBankTransfer"].includes(key) ? true : false,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.includes("transferDate") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Bank To Bank Transfer",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Bank To Bank Transfer");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        }, () => {
                            if (this.gridApi) {
                                this.gridApi.hideOverlay();
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    openPopUpFromURLId = (id) => {
        this.setState({ idBankToBankTransfer: id }, () => {
            this.getBankToBankTransferSelectbyID(this.state.idBankToBankTransfer);
        });
    };

    getColumnWidth = (key) => {
        const columnWidths = {
            "accountHead": window.innerWidth * 0.12,
            "fromACType": window.innerWidth * 0.06,
            "toACType": window.innerWidth * 0.06,
            "fromBank": window.innerWidth * 0.25,
            "toBank": window.innerWidth * 0.25,
            "amount": window.innerWidth * 0.06,
            "status": window.innerWidth * 0.06,
        };
        return columnWidths[key];
    };
    getPinnedWidth = (key) => {
        const pinnedWidths = {
            "sR.No": window.innerWidth * 0.05,
            "transferNo": window.innerWidth * 0.06,
            "transferDate": window.innerWidth * 0.07,
        }
        return pinnedWidths[key];
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        //debugger;
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        }, () => {
                            this.getBankToBankTransferCount();
                        });
                    } else {
                        this.setState({
                            table2Data: [],
                            table2ColDefs: [],
                            isTable2Expanded: false
                        }, () => {
                            this.getBankToBankTransferCount();
                        });
                    }
                }
            });
        }
    }

    getBankToBankTransferCount = () => {
        let request = {
            idCompany: this.state.idCompany,
            idFinancialYear: 0
        };
        this.accountTransactionServices.getBankToBankTransferCount(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let list = this.state.rowData;
                let maxIdPaymentMake = list.length > 0
                    ? Math.max(...list.map(item => item.idBankToBankTransfer))
                    : 0;
                let transferNo = String(maxIdPaymentMake + 1).padStart(3, '0');
                let data = this.state.bankToBankDetails;
                data.transferNo = transferNo;
                this.setState({
                    bankToBankDetails: data
                }, () => {
                    //this.usp_Master_GeneralProductSelect();
                });
            } else {
                //this.usp_Master_GeneralProductSelect();
            }
        });
    }

    usp_Master_GeneralProductSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                console.log(data);
                data = data.map((x) => ({
                    id: x.idGeneralProduct,
                    name: x.productName,
                }));
                let detail = this.state.bankToBankDetails;
                detail.aCCSubHeadList = data;
                detail.mainACCSubHeadList = data;
                this.setState({
                    bankToBankDetails: detail
                }, () => {
                    this.usp_Master_EmployeeSelect()
                }, () => {
                    if (this.gridApi) {
                        this.gridApi.hideOverlay();
                    }
                });
            } else {
                this.usp_Master_EmployeeSelect()
            }
        });
    }

    usp_Master_EmployeeSelect = () => {
        this.accountTransactionServices.usp_Master_EmployeeSelect_WithNewChanges(this.state.idCompany).then((response) => {
            // debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    id: x.idEmployee,
                    name: x.employeeName,
                    idGeneralProduct: x.idGeneralProduct,
                }));
                let Detail = this.state.bankToBankDetails;
                Detail.employeeList = data;
                Detail.mainEmployeeList = data;
                this.setState({
                    bankToBankDetails: Detail
                }, () => {
                    this.usp_Master_BankSelect();
                });
            } else {
                this.usp_Master_BankSelect();
            }
        });
    }

    usp_Master_BankSelect = () => {
        this.accountTransactionServices.usp_Master_BankSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                dynamicData = dynamicData.map((x) => ({
                    id: x.idBank,
                    name: x.bankName,
                    idGeneralProduct: x.idAccountSubHead,
                }));
                let bankToBankDetail = this.state.bankToBankDetails;
                bankToBankDetail.bankList = dynamicData;
                bankToBankDetail.mainBankList = dynamicData;

                bankToBankDetail.toBankList = dynamicData;
                bankToBankDetail.mainToBankList = dynamicData
                this.setState({
                    bankToBankDetails: bankToBankDetail
                }, () => {
                    this.usp_Master_PaymentModeSelect();
                });
            } else {
                this.usp_Master_PaymentModeSelect();
            }
        });
    }

    usp_Master_PaymentModeSelect = () => {
        this.accountTransactionServices.usp_Master_PaymentModeSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        id: x.idPaymentMode,
                        name: x.paymentMode,
                    }));
                    let bankToBankDetail = this.state.bankToBankDetails;
                    bankToBankDetail.paymentModeList = dynamicData;
                    bankToBankDetail.mainPaymentModeList = dynamicData;
                    this.setState({
                        bankToBankDetails: bankToBankDetail
                    }, () => {
                        //this.usp_Master_BankSelect();
                    });
                } else {
                    //this.usp_Master_BankSelect();
                }
            }
        });
    }

    getChequeBookNoSelectbyChequeBookSeriesForBankToBank = (idChequeBookMaster, updateStatus, idBankToBankTransfer) => {
        let request = {
            idChequeBookMaster: idChequeBookMaster,
            updateStatus: updateStatus,
            idBankToBankTransfer: idBankToBankTransfer,
        };
        this.accountTransactionServices.getChequeBookNoSelectbyChequeBookSeriesForBankToBank(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    id: x.idChequeBookDetails,
                    name: x.chequeNo,
                }));
                let bankToBankDetail = this.state.bankToBankDetails;
                bankToBankDetail.chequeNoList = data;
                bankToBankDetail.mainChequeNoList = data;
                this.setState({
                    bankToBankDetails: bankToBankDetail
                });
            }
        });
    }

    usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake = (id, updateStatus) => {
        let request = {
            idBank: id,
            updateStatus: updateStatus,
        };
        this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    id: x.idChequeBookMaster,
                    name: x.chequeBookSeries,
                }));
                let bankToBankDetail = this.state.bankToBankDetails;
                bankToBankDetail.seriesList = data;
                bankToBankDetail.mainSeriesList = data;
                this.setState({
                    bankToBankDetails: bankToBankDetail
                });
            }
        });
    }

    getBankToBankTransferSelectbyID = (id) => {
        //debugger;
        this.accountTransactionServices.getBankToBankTransferSelectbyID(id).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let request = {
                    idBank: data.idBank,
                    updateStatus: 1,
                }
                this.accountTransactionServices.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(request).then((response) => {
                    if (response.statusCode == 200 && response.responseItem !== null) {
                        let series = response.responseItem.responseContent;
                        series = series.map((x) => ({
                            id: x.idChequeBookMaster,
                            name: x.chequeBookSeries,
                        }));
                        let bankDetails = this.state.bankToBankDetails;
                        bankDetails.seriesList = series;
                        bankDetails.mainSeriesList = series;
                        this.setState({
                            bankToBankDetails: bankDetails
                        }, () => {
                            let req = {
                                idChequeBookMaster: data.idChequeBookMaster,
                                updateStatus: 1,
                                idBankToBankTransfer: data.idBankToBankTransfer,
                            };
                            this.accountTransactionServices.getChequeBookNoSelectbyChequeBookSeriesForBankToBank(req).then((response) => {
                                if (response.statusCode == 200 && response.responseItem !== null) {
                                    let chequeBookNo = response.responseItem.responseContent;
                                    //debugger;
                                    chequeBookNo = chequeBookNo.map((x) => ({
                                        id: x.idChequeBookDetails,
                                        name: x.chequeNo,
                                    }));
                                    let bankData = this.state.bankToBankDetails;
                                    bankData.chequeNoList = chequeBookNo;
                                    bankData.mainChequeNoList = chequeBookNo;
                                    this.setState({
                                        bankToBankDetails: bankData
                                    }, () => {
                                        //debugger
                                        let bankToBankDetail = this.state.bankToBankDetails;
                                        bankToBankDetail.idBankToBankTransfer = data.idBankToBankTransfer;
                                        bankToBankDetail.transferNo = data.transferNo;
                                        bankToBankDetail.transferDate = moment(data.transferDate).format('YYYY-MM-DD');
                                        bankToBankDetail.chequeDate = moment(data.chequeDate).format('YYYY-MM-DD');
                                        bankToBankDetail.refNo = data.referenceNo;
                                        bankToBankDetail.amount = data.amount;
                                        bankToBankDetail.remarks = data.remarks;
                                        //
                                        bankToBankDetail.idEmployee = data.idAuthorisedEmployee > 0 ? data.idAuthorisedEmployee : 0;
                                        bankToBankDetail.employeeName = data.idAuthorisedEmployee > 0 ? bankToBankDetail.mainEmployeeList?.find(item => item.id === data.idAuthorisedEmployee)?.name : "";

                                        bankToBankDetail.idGeneralProduct = data.idAccountHead > 0 ? data.idAccountHead : 0;
                                        bankToBankDetail.productName = data.idAccountHead > 0 ? bankToBankDetail.mainACCSubHeadList?.find(item => item.id === data.idAccountHead)?.name : "";

                                        bankToBankDetail.idBank = data.idBank > 0 ? data.idBank : 0;
                                        bankToBankDetail.bankName = data.idBank > 0 ? bankToBankDetail.mainToBankList?.find(item => item.id === data.idBank)?.name : "";
                                        //bankToBankDetail.idSelectBank = 0;
                                        //bankToBankDetail.selectBankName = "";
                                        bankToBankDetail.idPaymentMode = data.paymentMode > 0 ? data.paymentMode : 0;
                                        bankToBankDetail.paymentMode = data.paymentMode > 0 ? bankToBankDetail.mainPaymentModeList?.find(item => item.id === data.paymentMode)?.name : "";
                                        bankToBankDetail.idFinancialYear = 0;
                                        bankToBankDetail.e_Date = data.e_Date;
                                        bankToBankDetail.updateStatus = 1;
                                        bankToBankDetail.chequeNo = data.idChequeBookDetails > 0 ? bankToBankDetail.mainChequeNoList?.find(item => item.id === data.idChequeBookDetails) ? bankToBankDetail.mainChequeNoList?.find(item => item.id === data.idChequeBookDetails)?.name : "" : "";
                                        bankToBankDetail.idChequeBookDetails = bankToBankDetail.chequeNo ? data.idChequeBookDetails : 0;

                                        bankToBankDetail.idChequeBookMaster = data.idChequeBookMaster > 0 ? data.idChequeBookMaster : 0;
                                        bankToBankDetail.chequeBookSeries = data.idChequeBookMaster > 0 ? bankToBankDetail.mainSeriesList?.find(item => item.id === data.idChequeBookMaster)?.name : "";
                                        bankToBankDetail.fromAC = data.fromAC > 0 ? data.fromAC : 0;
                                        bankToBankDetail.fromACType = data.fromAC > 0 ? bankToBankDetail.mainBankList?.find(item => item.id === data.fromAC)?.name : "";
                                        this.setState({ bankToBankDetails: bankToBankDetail, isModalOpen: true });
                                    });
                                }
                            });
                        });
                    }
                });
            }
        });
    }

    submit = () => {
        //debugger;
        if (this.isSubmitting) { return; }
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let data = this.state.bankToBankDetails;
            let requestData = {
                idBankToBankTransfer: data.idBankToBankTransfer,
                transferNo: data.transferNo,
                transferDate: data.transferDate,
                idAccountHead: data.idGeneralProduct,
                paymentMode: data.idPaymentMode,
                idBank: data.idBank,
                type: data.selectBankTypeName,
                fromAC: data.fromAC,
                fromACType: data.fromAccountTypeName,
                chequeNo: (data.chequeNo && data.chequeNo !== "") ? data.chequeNo : null,
                chequeDate: (data.chequeDate !== 'Invalid date' ? data.chequeDate : ''),
                referenceNo: data.refNo,
                amount: data.amount,
                idCompany: this.state.idCompany,
                e_Date: data.idBankToBankTransfer > 0 ? data.e_Date : new Date().toISOString(),
                e_IDUser: data.idBankToBankTransfer > 0 ? data.e_IDUser : this.state.idUser,
                isUpdated: data.updateStatus === 1 ? true : null,
                updatedDate: new Date().toISOString(),
                u_IDUser: this.state.idUser,
                isDeleted: false,
                deletedDate: null,
                d_IDUser: null,
                idChequeBookDetails: data.idChequeBookDetails,
                idChequeBookMaster: data.idChequeBookMaster > 0 ? data.idChequeBookMaster : null,
                idAuthorisedEmployee: data.idEmployee,
                remarks: data.remarks,
                idFinancialYear: null,
                updateStatus: data.updateStatus,
            };
            this.isSubmitting = true;
            this.setState({ isSaving: true });
            this.accountTransactionServices.bankToBankTransferAddUpdate(requestData).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    let dynamicData = response.responseItem.responseContent;
                    if (dynamicData !== null) {
                        if (this.state.bankToBankDetails.updateStatus === 1) {
                            this.SwalServices.Success("Updated sucessfully.");
                        } else {
                            this.SwalServices.Success("Save sucessfully.");
                        }
                        if (this.state.urlId) {
                            this.setState({ route: '/ledger-report' });
                        } else {
                            this.setState({
                                isModalOpen: false,
                            }, () => {
                                this.procSelectAllRecordsSP();
                                this.resetDetails();
                            });
                        }
                    } else {
                        this.procSelectAllRecordsSP();
                        this.resetDetails();
                    }
                }
            }).finally(() => {
                this.isSubmitting = false;
                this.setState({ isSaving: false });
            });
        }
    }

    resetDetails = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let bankToBankDetail = this.state.bankToBankDetails;
        bankToBankDetail.idBankToBankTransfer = 0;
        // bankToBankDetail.transferNo = "";
        bankToBankDetail.transferDate = "";
        bankToBankDetail.chequeDate = "";
        bankToBankDetail.refNo = "";
        bankToBankDetail.amount = "";
        bankToBankDetail.remarks = "";
        //employeeList: [],
        bankToBankDetail.idEmployee = 0;
        bankToBankDetail.employeeName = "";
        bankToBankDetail.idGeneralProduct = 0;
        bankToBankDetail.productName = "";
        bankToBankDetail.idBank = 0;
        bankToBankDetail.bankName = "";
        bankToBankDetail.idSelectBank = 0;
        bankToBankDetail.selectBankName = "";
        bankToBankDetail.idPaymentMode = 0;
        bankToBankDetail.paymentMode = "";
        bankToBankDetail.idFinancialYear = 0;
        bankToBankDetail.e_Date = "";
        bankToBankDetail.updateStatus = 0;
        bankToBankDetail.idChequeBookDetails = 0;
        bankToBankDetail.chequeNo = "";
        bankToBankDetail.chequeNoList = [];
        bankToBankDetail.idChequeBookMaster = 0;
        bankToBankDetail.chequeBookSeries = "";
        bankToBankDetail.seriesList = [];
        bankToBankDetail.fromAC = 0;
        bankToBankDetail.fromACType = "";
        this.setState({ bankToBankDetails: bankToBankDetail, validState: validState });
    }

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.resetDetails();
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            idBankToBankTransfer: event.data.idBankToBankTransfer, validState: validState
        }, () => {
            this.getBankToBankTransferSelectbyID(this.state.idBankToBankTransfer);
        });
    };

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };
    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetDetails();
        let data = this.state.bankToBankDetails;
        data.transferDate = moment(new Date().toISOString()).format('YYYY-MM-DD');
        this.setState({ isModalOpen: true, bankToBankDetails: data }, () => {
            this.getBankToBankTransferCount();
        });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.bankToBankDetails;
        details[name] = value;
        this.setState({ bankToBankDetails: details });
    }

    // handleSelectChange = (event, name) => {
    //     let select = event.target.value;
    //     let details = this.state.employeeBasicDetails;
    //     details[name] = select;
    //     this.setState({ employeeBasicDetails: details });
    // }

    handleSelectChange = (event, name) => {
        let data = this.state.bankToBankDetails;
        if (name === "aCCSubHeadList") {
            // debugger
            let arr = this.state.bankToBankDetails.mainACCSubHeadList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            data.productName = value;
            data.aCCSubHeadList = found;

        } else if (name === 'chequeNo') {
            //debugger
            let arr = this.state.bankToBankDetails.mainChequeNoList;
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            data.chequeNo = value;
            data.chequeNoList = found;

        } else if (name === 'PaymentMode') {
            //debugger
            let arr = [...this.state.bankToBankDetails.mainPaymentModeList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.bankToBankDetails;
            data.paymentMode = value;
            data.paymentModeList = found;
        } else if (name === 'FromAccount') {
            //debugger
            let arr = [...this.state.bankToBankDetails.mainBankList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.bankToBankDetails;
            data.fromACType = value;
            data.bankList = found;
        } else if (name === 'selectBank') {
            //debugger
            let arr = [...this.state.bankToBankDetails.mainToBankList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.bankToBankDetails;
            data.bankName = value;
            data.toBankList = found;
        } else if (name === 'selectSeries') {
            //debugger
            let arr = [...this.state.bankToBankDetails.mainSeriesList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.bankToBankDetails;
            data.chequeBookSeries = value;
            data.seriesList = found;
        } else if (name === 'employeeList') {
            //debugger
            let arr = [...this.state.bankToBankDetails.mainEmployeeList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.bankToBankDetails;
            data.employeeName = value;
            data.employeeList = found;
        }
        this.setState({ bankToBankDetails: data });
    }

    setFilterParameters = (id, name, drpIdentity) => {
        //debugger
        let data = this.state.bankToBankDetails;
        if (drpIdentity === 'aCCSubHeadList') {
            data.idGeneralProduct = id;
            data.productName = name;
        }
        if (drpIdentity === 'PaymentMode') {
            data.idPaymentMode = id;
            data.paymentMode = name;
        }
        if (drpIdentity === 'FromAccount') {
            if (data.idBank !== id) {
                data.fromAC = id;
                data.fromACType = name;
            } else {
                this.SwalServices.Alert('Please Select Different Bank')
            }
        }
        if (drpIdentity === 'selectBank') {
            if (data.fromAC !== id) {
                data.idBank = id;
                data.bankName = name;
                data.idChequeBookMaster = 0;
                data.chequeBookSeries = "";
                data.seriesList = [];
                data.idChequeBookDetails = 0;
                data.chequeNo = "";
                data.chequeNoList = [];
                data.idGeneralProduct = data.mainBankList?.find(x => x.id === id)?.idGeneralProduct > 0 ? data.mainBankList?.find(x => x.id === id)?.idGeneralProduct : 0;
                data.productName = data.mainACCSubHeadList?.find(x => x.id === data.idGeneralProduct)?.name && data.idGeneralProduct > 0 ? data.mainACCSubHeadList?.find(x => x.id === data.idGeneralProduct)?.name : "";
            } else {
                this.SwalServices.Alert('Please Select Different Bank')
            }
        }
        if (drpIdentity === 'selectSeries') {
            data.idChequeBookMaster = id;
            data.chequeBookSeries = name;
            data.idChequeBookDetails = 0;
            data.chequeNo = "";
            data.chequeNoList = [];
        }
        if (drpIdentity === 'chequeNo') {
            data.idChequeBookDetails = id;
            data.chequeNo = name;
        }
        if (drpIdentity === 'employeeList') {
            data.idEmployee = id;
            data.employeeName = name;
        }
        //if()
        this.setState({ bankToBankDetails: data }, () => {
            if (drpIdentity === 'selectBank') {
                this.usp_Master_ChequeBookSeriesSelectbyBank_ForPaymentMake(id, this.state.bankToBankDetails.updateStatus);
            } else if (drpIdentity === 'selectSeries') {
                this.getChequeBookNoSelectbyChequeBookSeriesForBankToBank(id, this.state.bankToBankDetails.updateStatus, this.state.bankToBankDetails.idBankToBankTransfer)
            }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.bankToBankDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='bank-transfer'>
                <div className="data-display">
                    <div className="data-display-inner relative">
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: this.handleSave,
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <BankToBankTransferTable
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            handleSelectChange={this.handleSelectChange.bind(this)}
                            bankToBankDetails={this.state.bankToBankDetails}
                            validState={this.state.validState}
                            submit={this.submit.bind(this)}
                            isSaving={this.state.isSaving}
                            close={this.closePopup.bind(this)}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Bank to bank transfer</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onCellClicked={this.handleCellClick}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                        {/* <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                />
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        )
    }
}
export default BankToBankTransfer;